import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import cn from 'classnames';
import { BaseComponent } from '../../../components/BaseComponent';
import { getAllProductTasks, getProductTasks } from '../../products/actions';
import {
  REQUEST_ADD_PRODUCT_TASK,
  REQUEST_DELETE_PRODUCT_TASK,
  REQUEST_GET_ALL_PRODUCT_TASKS,
  REQUEST_GET_PRODUCT_TASKS,
} from '../constants';
import { selectMe, selectWorks } from '../../Api/selectors';
import { selectAllProductTasks, selectProductTasks } from '../../products/selectors';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Form';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { deleteVehicleProperty, setVehicleProperties } from '../actions';
import { selectVehicle } from '../selectors';
import { Cell, List, Row } from '../../../components/List';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import styles from './VehicleProductTasksSection.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  width: 100%;
  background: white;
  padding: 22px;

  .basic-multi-select {
    width: 100%;
    max-width: 100%;
  }
`;

export const TaskAssignable = {
  Arjan: '1',
  Len: '2',
  Stefan: '3',
  Overig: '4',
  Teun: '5',
};
const PRODUCT_TASK_OTHER_NAME = 'product_task_other';
const PRODUCT_TASK_OTHER_LABEL = 'Overige taak';

const TRANSPORT_TASK = 'HOOI_NEW_TASK_transport_order';

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

const STATE = {
  selectedTask: null,
  taskDescription: null,
  taskTitle: null,
  linkToProduct: '1', // standaard op 'ja'
  taskPerson: '4', // Default to "Overig"
};

class VehicleProductTasksSectionComp extends BaseComponent {
  constructor(props) {
    const initial = { ...STATE };
  
    const fromKanban =
      props?.fromKanban === true ||
      props?.location === 'fromKanban' ||
      props?.locations === 'fromKanban' ||
      (props?.location && typeof props.location === 'object' && props.location.state?.fromKanban === true);
  
    // if (fromKanban) {
    //   initial.selectedTask = TRANSPORT_TASK;
    // }

    super(props, initial);
    this.isFromKanban && (this.state.selectedTask = 'HOOI_NEW_TASK_transport_order');

  }
  

  componentDidMount() {
    this.props.getAllProductTasks();
    this.props.geProductTasks();
  }

  get isFromKanban() {
    return this.props.fromKanban === true;
  }

  get availableTasksOptions() {
    let options = (this.props.allTasks ?? []).map(t => ({ label: t.label, name: t.name }));

    options.push({ name: PRODUCT_TASK_OTHER_NAME, label: PRODUCT_TASK_OTHER_LABEL });

    return options;
  }

  get availableTasksOptions() {
    const allTasks = this.props.allTasks ?? [];
    const grouped = [];

    // Groep: Standaardtaken (prio 1)
    const standardTasks = allTasks.filter(t => t.prio === '1' && !t.type);
    let currentGroup = { label: 'Standaardtaken', options: [] };

    for (const task of standardTasks) {
      currentGroup.options.push({ label: task.label, value: task.name });
    }
    if (currentGroup.options.length) grouped.push(currentGroup);

    // Groep: Overige taken (prio !== 1)
    const otherPriorityTasks = allTasks.filter(t => t.prio !== '1' && !t.type);
    if (otherPriorityTasks.length) {
      grouped.push({
        label: 'Overige taken',
        options: otherPriorityTasks.map(task => ({
          label: task.label,
          value: task.name,
        })),
      });
    }

    // Groep: Speciale taak
    grouped.push({
      label: 'Speciale taak',
      options: [{ label: PRODUCT_TASK_OTHER_LABEL, value: PRODUCT_TASK_OTHER_NAME }],
    });

    return grouped;
  }

  get otherTasks() {
    const tasks = this.props.vehicle?.properties?.filter(
      p => p?.propertyName?.name?.indexOf('product_task_other_task') === 0,
    );

    return tasks;
  }

  get otherTasksOptions() {
    const taskOptions = this.otherTasks
      ?.filter(t => t?.propertyName?.name)
      ?.map((t, i) => {
        const index = +t?.propertyName?.name?.slice(24);
        const task = `${PRODUCT_TASK_OTHER_NAME}_${index}_title`;
        const description = `${PRODUCT_TASK_OTHER_NAME}_${index}_description`;
        const person = `${PRODUCT_TASK_OTHER_NAME}_${index}_person`;
        return {
          name: this.props.vehicle?.[task] || '',
          description: this.props.vehicle?.[description] || '',
          index,
        };
      });
    return taskOptions ?? [];
  }

  get otherTasksNumbers() {
    return this.otherTasks
      ?.filter(t => t?.propertyName?.name)
      ?.map(t => +t?.propertyName?.name?.slice(24))
      ?.sort();
  }

  getVehicleTasks() {
    const vehicletasks = this.availableTasksOptions?.map(t => {
      let task = this.props.vehicle?.[t?.name] === '1' ? t?.name : null;
      let description = this.props.vehicle?.[`${t?.name}_description`];
      let person = this.props.vehicle?.[`${t?.name}_person`];

      return {
        name: task,
        description,
        person,
      };
    });

    return vehicletasks ?? [];
  }

  getVehicleTasks2() {
    const vehicletasks = this.availableTasksOptions2?.map(t => {
      let task = this.props.vehicle?.[t?.name] === '1' ? t?.name : null;
      let description = this.props.vehicle?.[`${t?.name}_description`];
      let person = this.props.vehicle?.[`${t?.name}_person`];

      return {
        name: task,
        description,
        person,
      };
    });

    return vehicletasks ?? [];
  }

  renderEditModal() {
    if (!this.state.renderEdit) return '';

    return (
      <Modal onClose={this.setStateFn({ renderEdit: false })} title={this.lbl(`workflows.details.tasks.editModalTitle`)}>
        <FormField>
          <Input name="newTaskName" value={this.state.newTaskName ?? ''} onChange={this.onInputChange.bind(this)} />
        </FormField>
        <ModalControls>
          <Button
            onClick={() => {
              this.editTask();
              this.setState({ renderEdit: false, oldTaskName: null });
            }}
            disabled={this.confirmEditBtnDisabled}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ renderEdit: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  onClickAddNewTask() {
    // Disable the button while processing
    this.setState({ isAddingTask: true });
  
    let properties = [];
  
    if (this.state.selectedTask !== PRODUCT_TASK_OTHER_LABEL) {
      properties.push({
        propertyName: this.state.selectedTask,
        propertyValue: '1',
      });
  
      if (this.state.taskDescription) {
        const remarks = JSON.stringify([{ text: this.state.taskDescription }]);
        properties.push({
          propertyName: `${this.state.selectedTask}_remarks`,
          propertyValue: remarks,
        });
      }
  
      if (this.state.taskPerson) {
        properties.push({
          propertyName: `${this.state.selectedTask}_person`,
          propertyValue: this.state.taskPerson,
        });
      }
    }
  
    if (this.state.selectedTask === PRODUCT_TASK_OTHER_NAME) {
      let index = this.otherTasks?.length + 1;
  
      if (this.otherTasksNumbers?.includes(index)) {
        index = this.otherTasksNumbers?.slice(-1)?.[0] + 1;
      }
      properties.push({
        propertyName: this.state.selectedTask + `_task_${index}`,
        propertyValue: '1',
      });
      properties.push({
        propertyName: `${this.state.selectedTask}_${index}_title`,
        propertyValue: this.state.taskTitle,
      });
      if (this.state.taskDescription) {
        const remarks = JSON.stringify([{ text: this.state.taskDescription }]);
        properties.push({
          propertyName: `${this.state.selectedTask}_${index}_remarks`,
          propertyValue: remarks,
        });
      }
      if (this.state.taskPerson) {
        properties.push({
          propertyName: `${this.state.selectedTask}_${index}_person`,
          propertyValue: this.state.taskPerson,
        });
      }
      properties.push({
        propertyName: `${this.state.selectedTask}_${index}_user_id`,
        propertyValue: this.props.me?.id,
      });
    }
  
    this.props.addNewVehicleProductTask(
      properties,
      result => {
        this.reset();
        // Re-enable button
        this.setState({ isAddingTask: false });
        if (this.props.onAdded) this.props.onAdded();
      },
      {
        addLinkedProducts: this.state.linkToProduct === '1',
      }
    );
  }
  

  reset() {
    this.setState({
      selectedTask: null,
      taskDescription: '',
      taskPerson: '',
      taskTitle: '',
      linkToProduct: '1', // reset naar 'ja'
    });
  }

  deleteTask(task) {
    if (task?.index) {
      const { index } = task;
      this.props.deleteTask(PRODUCT_TASK_OTHER_NAME + `_task_${index}`);
      this.props.deleteTask(`${PRODUCT_TASK_OTHER_NAME}_${index}_title`);
      this.props.deleteTask(`${PRODUCT_TASK_OTHER_NAME}_${index}_description`);
      this.props.deleteTask(`${PRODUCT_TASK_OTHER_NAME}_${index}_remarks`);
      this.props.deleteTask(`${PRODUCT_TASK_OTHER_NAME}_${index}_user_id`);
      this.props.deleteTask(`${PRODUCT_TASK_OTHER_NAME}_${index}_person`);
      return;
    }

    this.props.deleteTask(task?.name);
    this.props.deleteTask(`${task?.name}_description`);
    this.props.deleteTask(`${task?.name}_person`);
  }

  onChangeSelectedTask(evt) {
    this.setState({ selectedTask: evt.value });
  }

  render() {
    return (
      <>
        <Container>
          <HBox left className="field-block">
            <VBox>
              {env.clientId != AppClientId.HILTERMANN && (
                <List className="mb-3">
                  {[...this.getVehicleTasks(), ...this.otherTasksOptions]
                    ?.filter(t => t?.name)
                    ?.map(task => {
                      return (
                        <Row key={task?.name}>
                          <Cell>{this.lbl(`vehicle.property.${task?.name}`)}</Cell>
                          <Cell>{task?.description}</Cell>
                          <IconWrapper color="red">
                            <div
                              onClick={evt => {
                                evt.stopPropagation();
                                this.deleteTask(task);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <FontAwesomeIcon icon={faTimesCircle} />
                            </div>
                          </IconWrapper>
                        </Row>
                      );
                    })}
                </List>
              )}

{!this.isFromKanban &&  <div className="mb-3 w-100">
                <label className="form-label">{this.lbl('workflows.details.Taken toevoegen')}</label>
                <div className="mb-3 w-100">

 
    <SearchSelect
      options={this.availableTasksOptions}
      value={
        this.state.selectedTask
          ? {
              label: this.lbl(`product.details.tasks.${this.state.selectedTask}`),
              value: this.state.selectedTask,
            }
          : null
      }
      onChange={evt => this.setState({ selectedTask: evt?.value })}
    />
  
</div>

              </div>}
              {this.state.selectedTask === PRODUCT_TASK_OTHER_NAME && (
                <div className="mb-3 w-100">
                  <label className="form-label">{this.lbl('workflows.column.name')}</label>
                  <input
                    style={{ width: '100%' }}
                    className="form-control"
                    value={this.state.taskTitle}
                    onChange={e => this.setState({ taskTitle: e.target.value })}
                  />
                </div>
              )}
              {this.state.selectedTask && env.clientId !== AppClientId.HILTERMANN && (
                <>
                  <div className="mb-3 w-100">
                    <label className="form-label">
                      {this.lbl(this.isFromKanban ? 'vehicle.property.transport_location_order_key_program_dealer' : 'invoice.description')}
                    </label>
                    <input
                      className="form-control"
                      value={this.state.taskDescription}
                      onChange={e => this.setState({ taskDescription: e.target.value })}
                    />
                  </div>

                  <div className="d-flex justify-content-center mb-3">
                    <strong>{this.lbl('product.details.tasks.applyDefaultProductConfirmation')}</strong>
                    <div className="d-flex gap-2 justify-content-center">
                      <Button
                        className={cn(styles.buttonGroupItem, {
                          [styles.selectedButton]: this.state.linkToProduct === '1',
                        })}
                        small
                        onClick={() => this.setState({ linkToProduct: '1' })}
                      >
                        {this.lbl('yes')}
                      </Button>
                      <Button
                        className={cn(styles.buttonGroupItem, {
                          [styles.selectedButton]: this.state.linkToProduct === '0',
                        })}
                        small
                        onClick={() => this.setState({ linkToProduct: '0' })}
                      >
                        {this.lbl('no')}
                      </Button>
                    </div>
                  </div>
                </>
              )}



 { this.state.selectedTask && (
              <HBox right gap={'8px'}>
                {env.clientId !== AppClientId.HILTERMANN ?  (
                  <ButtonComponent

                 
                  
                    //disabled={!this.state.linkToProduct}
                    style={'ButtonSoftEdit'}
                    onClick={this.onClickAddNewTask.bind(this)}
                  >



                    {this.lbl(!this.isFromKanban ? this.lbl('workflows.details.add_task') : this.lbl('vehicle.property.transport_tasks_save'))} 
                  </ButtonComponent>
                ) : (
                  <ButtonComponent
                    //disabled={!this.state.linkToProduct}
                    style={'ButtonSoftEdit'}
                    onClick={this.onClickAddNewTask.bind(this)}
                  >
                    {this.lbl('workflows.details.add_task')}
                  </ButtonComponent>
                )}
                <ButtonComponent
                  style={'ButtonSoftDelete'}
                  onClick={() => {
                    this.reset();
                  }}
                >
                  {this.lbl('workflows.details.reset')}
                </ButtonComponent>
              </HBox>
 )}


            </VBox>
          </HBox>
          {this.renderEditModal()}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_GET_ALL_PRODUCT_TASKS,
      REQUEST_GET_PRODUCT_TASKS,
      REQUEST_ADD_PRODUCT_TASK,
      REQUEST_DELETE_PRODUCT_TASK,
    ]),
    allTasks: selectAllProductTasks(),
    productTasks: selectProductTasks(),
    vehicle: selectVehicle(ownProps.vehicleId),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getAllProductTasks() {
      dispatch(getAllProductTasks());
    },
    geProductTasks() {
      dispatch(getProductTasks(ownProps.product_id));
    },
    addNewVehicleProductTask(properties, callback, options) {
      dispatch(setVehicleProperties(ownProps.vehicleId, properties, callback, options));
    },
    deleteTask(propertyName) {
      dispatch(deleteVehicleProperty(ownProps.vehicleId, propertyName));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleProductTasksSection = compose(withConnect, withRouter)(VehicleProductTasksSectionComp);
